import { render, staticRenderFns } from "./loteProducaoForm.vue?vue&type=template&id=06c16dde&scoped=true&"
import script from "./loteProducaoForm.vue?vue&type=script&lang=js&"
export * from "./loteProducaoForm.vue?vue&type=script&lang=js&"
import style0 from "./loteProducaoForm.vue?vue&type=style&index=0&id=06c16dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c16dde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VFlex,VForm,VIcon,VLayout,VTextField})
